









































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";
import { channelTypes } from "@/config/channels/channel-types.config.json";

import SubmitResetButtonGroop from "../../buttons/submit-reset-button-groop.vue";
import UploadingImageToServer from "../../app/images/uploading-image-to-server.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import {
  ipBroadcastTypes,
  languages,
  channelType,
  polarizations,
  rfBroadcastTypes,
  videoStreamTypes,
  audioStreamTypes,
} from "@/config/channels/channel-types.config.json";

@Component({
  components: { SubmitResetButtonGroop, UploadingImageToServer, BSwitch },
})
export default class AddChannelFromPRO extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel;
  @Prop({ type: Array, default: [] }) contentTypes!: Array<IContentType>;
  @Prop({ type: String, default: null }) formType!: string;
  @Prop({ type: String, default: "tv" }) activeType!: string;

  programNumber = 0;
  frequency = 0;
  symbolRate = 0;
  satelliteId = 0;
  videoPid = 0;
  audioPid = 0;
  logicalNumber = 0;
  majorNumber = 0;
  minorNumber = 0;
  plpId = 0;
  pcrPid = 0;
  sourceAddress = "";
  ip = "";
  port = 0;

  ipBroadcastType = 0;
  channelType = 0;
  polarization = 0;
  rfBroadcastType = 0;
  videoStreamType = 0;
  audioStreamType = 0;

  name = "";
  sortOrder = 0;
  language = "";

  contentType = "";
  posterName = "";
  showChannel = true;
  logicalNumberOnLinkedTv: number | null = null;

  channelTypes = channelType;
  ipBroadcastTypes = ipBroadcastTypes;
  polarizations = polarizations;
  rfBroadcastTypes = rfBroadcastTypes;
  videoStreamTypes = videoStreamTypes;
  audioStreamTypes = audioStreamTypes;
  languages = languages;

  get ipBroadcastTypeName(): string {
    const type = this.ipBroadcastTypes.find(
      (el) => el.id == this.ipBroadcastType
    );
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("forms.no-data"));
  }

  get channelTypeName(): string {
    const type = this.channelTypes.find((el) => el.id == this.channelType);
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("forms.no-data"));
  }

  get polarizationName(): string {
    const polarization = this.polarizations.find(
      (p) => p.id == this.polarization
    );
    return polarization
      ? polarization.name
      : String(this.$i18n.t("forms.no-data"));
  }

  get getRfBroadcastType(): string {
    const type = this.rfBroadcastTypes.find(
      (p) => p.id == this.rfBroadcastType
    );
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("forms.no-data"));
  }

  get videoStreamTypeName(): string {
    const type = this.videoStreamTypes.find(
      (p) => p.id == this.videoStreamType
    );
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("forms.no-data"));
  }

  get audioStreamTypeName(): string {
    const type = this.audioStreamTypes.find(
      (p) => p.id == this.audioStreamType
    );
    return type
      ? `${type.name}: ${type.id}`
      : String(this.$i18n.t("forms.no-data"));
  }

  get channelLanguage(): string {
    const language = this.languages.find((l) => l.lang == this.language);
    return language ? language.name : String(this.$i18n.t("forms.no-data"));
  }

  get contentTypeName(): string {
    const type = this.contentTypes.find((el) => el._id == this.contentType);
    return type
      ? this.$getLocale(type.name)
      : String(this.$i18n.t("forms.no-data"));
  }

  get type(): number {
    const i = channelTypes.findIndex((t) => t == this.activeType);
    return i < 0 ? 1 : i + 1;
  }

  get ch(): Partial<IChannel> {
    return {
      data: {
        audioPid: this.audioPid,
        audioStreamType: this.audioStreamType,
        channelType: this.channelType, // channelType из channel-types
        frequency: this.frequency,
        logicalNumber: this.logicalNumber,
        majorNumber: this.majorNumber,
        minorNumber: this.minorNumber,
        pcrPid: this.pcrPid,
        plpId: this.plpId,
        ip: this.ip,
        port: this.port,
        ipBroadcastType: this.ipBroadcastType,
        polarization: this.polarization,
        programNumber: this.programNumber,
        rfBroadcastType: this.rfBroadcastType,
        satelliteId: this.satelliteId,
        symbolRate: this.symbolRate,
        videoPid: this.videoPid,
        videoStreamType: this.videoStreamType,
        sourceAddress: this.sourceAddress,
      },
      _id: undefined,
      image: this.posterName,
      name: this.name,
      show: this.showChannel,
      sort_order: this.sortOrder,
      language: this.language,
      type: this.channel ? this.channel.type : this.type, //channel / radio
      content_type: this.contentType,
      logical_number_on_linked_tv: this.logicalNumberOnLinkedTv ?? 0,
    };
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("update", this.ch);
  }

  onReset(): void {
    this.programNumber = 0;
    this.frequency = 0;
    this.symbolRate = 0;
    this.satelliteId = 0;
    this.videoPid = 0;
    this.audioPid = 0;
    this.logicalNumber = 0;
    this.majorNumber = 0;
    this.minorNumber = 0;
    this.plpId = 0;
    this.pcrPid = 0;
    this.sourceAddress = "";
    this.ip = "";
    this.port = 0;

    this.ipBroadcastType = 0;
    this.channelType = 0;
    this.polarization = 0;
    this.rfBroadcastType = 0;
    this.videoStreamType = 0;
    this.audioStreamType = 0;

    this.name = "";
    this.sortOrder = 0;
    this.language = "";
    this.contentType = "";
    this.showChannel = true;
    this.posterName = "";
    this.logicalNumberOnLinkedTv = null;
  }

  @Watch("channel")
  valueDistribution(): void {
    if (!this.channel || !this.channel.data) return;
    this.programNumber = this.channel.data.programNumber;
    this.frequency = this.channel.data.frequency;
    this.symbolRate = this.channel.data.symbolRate;
    this.satelliteId = this.channel.data.satelliteId;
    this.videoPid = this.channel.data.videoPid;
    this.audioPid = this.channel.data.audioPid;
    this.logicalNumber = this.channel.data.logicalNumber;
    this.majorNumber = this.channel.data.majorNumber;
    this.minorNumber = this.channel.data.minorNumber;
    this.plpId = this.channel.data.plpId;
    this.pcrPid = this.channel.data.pcrPid;
    this.sourceAddress = this.channel.data.sourceAddress;
    this.ip = this.channel.data.ip;
    this.port = this.channel.data.port;

    this.ipBroadcastType = this.channel.data.ipBroadcastType;
    this.channelType = this.channel.data.channelType;
    this.polarization = this.channel.data.polarization;
    this.rfBroadcastType = this.channel.data.rfBroadcastType;
    this.videoStreamType = this.channel.data.videoStreamType;
    this.audioStreamType = this.channel.data.audioStreamType;
    this.posterName = this.channel.image;

    this.name = this.channel.name;
    this.sortOrder = this.channel.sort_order;
    this.language = this.channel.language;
    this.contentType = this.channel.content_type;
    this.showChannel = this.channel.show;
    this.logicalNumberOnLinkedTv =
      this.channel.logical_number_on_linked_tv ?? null;
  }

  mounted(): void {
    this.valueDistribution();
  }
}
